import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const api = createApi({
    reducerPath: 'platformApi',
    baseQuery: fetchBaseQuery({ baseUrl: '/api/' }),
    refetchOnReconnect: true,
    endpoints: (builder) => ({
        // ConvertedVideo
        getConvertedVideoByUuid: builder.query({
            query: (id) => `converted_videos/${id}.json`,
        }),

        // CreationLabel
        getCreationLabelByUuid: builder.query({
            query: (id) => `creation_labels/${id}.json`,
        }),
        getCreationLabels: builder.query({
            query: () => `creation_labels.json`,
            transformResponse: (baseQueryReturnValue, meta, arg) => {
                return baseQueryReturnValue.sort((prev, next) => new Date(next.createdAt) - new Date(prev.createdAt));
            },
        }),

        // LibraryVideo
        getLibraryVideoByUuid: builder.query({
            query: (id) => `library_videos/${id}.json`,
        }),

        // MediaObject
        getMediaObjectByUuid: builder.query({
            query: (id) => `media_objects/${id}.json`,
        }),

        // PlaylistTemplate
        getPlaylistTemplateByUuid: builder.query({
            query: (id) => `playlist_templates/${id}.json`,
        }),
        addNewPlaylistTemplate: builder.mutation({
            query: playlistTemplate => ({
                url: `/playlist_templates.json`,
                method: 'POST',
                body: playlistTemplate
            })
        }),
        addNewPlaylistTemplateMultiple: builder.mutation({
            query: body => ({
                url: `/playlist_templates/multiple.json`,
                method: 'POST',
                body: body
            })
        }),

        // Playlist
        getPlaylistByUuid: builder.query({
            query: (id) => `playlists/${id}.json`,
        }),
        getPlaylists: builder.query({
            query: () => `playlists.json`,
            transformResponse: (baseQueryReturnValue, meta, arg) => {
                return baseQueryReturnValue.sort((prev, next) => new Date(next.createdAt) - new Date(prev.createdAt));
            },
        }),
        getPlaylistsFromScreenUuid: builder.query({
            query: (args) => `screens/${args.id}/playlists.json`,
            transformResponse: (baseQueryReturnValue, meta, arg) => {
                return baseQueryReturnValue.sort((prev, next) => new Date(next.createdAt) - new Date(prev.createdAt));
            },
        }),

        // RealEstateModuleObject
        getRealEstateModuleObjectByUuid: builder.query({
            query: (id) => `real_estate_module_objects/${id}.json`,
        }),
        getRealEstateModuleObjects: builder.query({
            query: (id) => `real_estate_module_objects.json`,
            transformResponse: (baseQueryReturnValue, meta, arg) => {
                return baseQueryReturnValue.sort((prev, next) => new Date(next.createdAt) - new Date(prev.createdAt));
            },
        }),

        // RealEstateModulePhoto
        getRealEstateModulePhotoByUuid: builder.query({
            query: (id) => `real_estate_module_photos/${id}.json`,
        }),

        // RealEstateModuleTag
        getRealEstateModuleTagByUuid: builder.query({
            query: (id) => `real_estate_module_tags/${id}.json`,
        }),
        getRealEstateModuleTags: builder.query({
            query: () => `real_estate_module_tags.json`,
            transformResponse: (baseQueryReturnValue, meta, arg) => {
                return baseQueryReturnValue.sort((prev, next) => new Date(next.createdAt) - new Date(prev.createdAt));
            },
        }),

        // ScreenPlaylist
        getScreenPlaylistByUuid: builder.query({
            query: (id) => `screen_playlists/${id}.json`,
        }),
        addNewScreenPlaylist: builder.mutation({
            query: screenPlaylist => ({
                url: `screen_playlists.json`,
                method: 'POST',
                body: screenPlaylist
            })
        }),
        addNewScreenPlaylistMultiple: builder.mutation({
            query: body => ({
                url: `screen_playlists/multiple.json`,
                method: 'POST',
                body: body
            })
        }),

        // Screen
        getScreenByUuid: builder.query({
            query: (id) => `screens/${id}.json`,
        }),
        getScreens: builder.query({
            query: () => `screens.json`,
            transformResponse: (baseQueryReturnValue, meta, arg) => {
                return baseQueryReturnValue.sort((prev, next) => new Date(next.createdAt) - new Date(prev.createdAt));
            },
        }),

        // Templates
        getTemplateByUuid: builder.query({
            query: (id) => `templates/${id}.json`,
        }),
        getTemplates: builder.query({
            query: () => `templates.json`,
            transformResponse: (baseQueryReturnValue, meta, arg) => {
                return baseQueryReturnValue.sort((prev, next) => new Date(next.createdAt) - new Date(prev.createdAt));
            },
        }),
        getTemplatesFromPlaylistUuid: builder.query({
            query: (args) => `playlists/${args.id}/templates.json`,
            transformResponse: (baseQueryReturnValue, meta, arg) => {
                return baseQueryReturnValue.sort((prev, next) => new Date(next.createdAt) - new Date(prev.createdAt));
            },
        }),

        // User
        getUserByUuid: builder.query({
            query: (id) => `users/${id}.json`,
        }),


    }),
})

// Export hooks for usage in functional components, which are auto-generated based on the defined endpoints
export const {
    useGetConvertedVideoByUuidQuery,
    useGetCreationLabelByUuidQuery,
    useGetCreationLabelsQuery,
    useGetLibraryVideoByUuidQuery,
    useGetMediaObjectByUuidQuery,
    useGetPlaylistByUuidQuery,
    useGetPlaylistsQuery,
    useGetPlaylistTemplateByUuidQuery,
    useAddNewPlaylistTemplateMutation,
    useAddNewPlaylistTemplateMultipleMutation,
    useAddNewScreenPlaylistMultipleMutation,
    useGetTemplateByUuidQuery,
    useGetUserByUuidQuery,
    useGetRealEstateModuleObjectByUuidQuery,
    useGetRealEstateModuleObjectsQuery,
    useGetRealEstateModulePhotoByUuidQuery,
    useGetRealEstateModuleTagByUuidQuery,
    useGetRealEstateModuleTagsQuery,
    useGetScreenByUuidQuery,
    useGetScreenPlaylistByUuidQuery,
    useAddNewScreenPlaylistMutation,
    useAddNewScreenPlaylistMutationMultiple,
    useGetScreensQuery,
    useGetTemplatesQuery,
    useGetTemplatesFromPlaylistUuidQuery,
    useGetPlaylistsFromScreenUuidQuery,
} = api
